import Hero from "@/components/home/Hero";
import Partners from "@/components/home/Partners";
import Services from "@/components/home/Services";
import SocSection from "@/components/home/SocSection";
import Capabilities from "@/components/home/Capabilities";
import Testimonials from "@/components/home/Testimonials";
import InsightsPreview from "@/components/home/InsightsPreview";
import CtaBand from "@/components/home/CtaBand";

export default function Home() {
  return (
    <>
      <Hero />
      <Partners />
      <Services />
      <SocSection />
      <Capabilities />
      <Testimonials />
      <InsightsPreview />
      <CtaBand />
    </>
  );
}
